<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<div #user_list class="at-who">
  <mat-action-list appScrollable id="at_who_user_list" tabindex="1" (infiniteScroll)="getNextBatch()"
    [complete]="!sapi.loadNext" msDivInfiniteScroll>
    @for (user of filtered_users; track user) {
      <button (click)="addWho(user)" (mouseover)="updateCurrent(user)"
        [ngClass]="{'current': user===filtered_users[list_index]}"
        mat-list-item> {{user.attributes.name + ' ' + (user.attributes.last_name || '')}}<br>
      {{'@' + user.attributes.username.trim()}} </button>
    }
    @if (sapi.loadingAvailable) {
      <div class="stage option-loading">
        <div class="dot-flashing"></div>
      </div>
    }
    @if (!sapi.loadingAvailable && filtered_users?.length == 0) {
      <div class="row center option-loading">
        No results found
      </div>
    }
  </mat-action-list>
</div>
